import { Controller } from "@hotwired/stimulus"
import ymaps from 'ymaps';

// Connects to data-controller="maps"
export default class extends Controller {
  static targets = ["map"]
  connect() {
    ymaps
      .load("https://api-maps.yandex.ru/2.1/?apikey=6b988ecc-2f7c-4f31-b7a6-95e324a38fc0&lang=ru_RU")
      .then(maps => {
        const map = new maps.Map(this.mapTarget, {
          center: [this.mapTarget.dataset.lat, this.mapTarget.dataset.lng],
          zoom: 12
        });

        let places = JSON.parse(this.mapTarget.dataset.places);
        console.log(places)
        places.forEach(place => {

          let myGeoObject = new maps.GeoObject({
            // Описание геометрии.
            geometry: {
              type: "Point",
              coordinates: [place.latitude, place.longitude]
            },
            // Свойства.
            properties: {
              // Контент метки.
              iconCaption: place.name,
              hintContent: place.name
            }
          }, {
            // https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/option.presetStorage.html
            preset: 'islands#blueMassTransitIcon',
            // preset: 'islands#blueAirportIcon',
            iconColor: '#3b5998',
            // Метку можно перемещать.
            // draggable: true
          });

          console.log(myGeoObject)

          map.geoObjects.add(myGeoObject);
        });
      })
      .catch(error => console.log('Failed to load Yandex Maps', error));
  }
}
